import styled from 'styled-components';

export const ModalContentWrapper = styled('div')`
  padding: 32px;
  color: #304e5c;
  font-size: 16px;
`;

export const ItemWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 35px;
`;

export const Circle = styled.div`
  border: ${(props) => props.theme.circle_border};
  border-radius: 50%;
  width: 26px;
  height: 26px;
  position: relative;
  display: flex;
  background: ${(props) => props.theme.circle_background};
  & > img {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const Name = styled.div`
  font-size: 14px;
  margin-left: 16px;
  width: 150px;
  cursor: ${(props) => props.theme.name_cursor};
  padding-bottom: ${(props) => props.theme.name_padding};
  color: ${(props) => props.theme.name_color};
  border-bottom: ${(props) => props.theme.name_border};
  & > svg {
    float: right;
  }
`;

export const checkedTheme = {
  circle_background: 'transparent',
  circle_border: '1px solid #4AA200',
  name_color: '#4AA200',
  name_border: 'none',
  name_padding: 'none',
  name_cursor: 'default',
};

export const activeTheme = {
  circle_background: '#C3CFD6',
  circle_border: 'transparent',
  name_color: '#1686CE',
  name_border: '1px solid #1686CE',
  name_padding: '10px',
  name_cursor: 'pointer',
};

export const disabledTheme = {
  circle_background: 'transparent',
  circle_border: '1px solid #C3CFD6',
  name_color: '#C3CFD6',
  name_border: 'none',
  name_padding: 'none',
  name_cursor: 'not-allowed',
};
